import React from 'react';
import { AllieButton, AllieImg, AllieText } from '@allie/app-ui-lib';
import { CreateSuccessContainer } from './CreateSuccess.styles';
import { isMobile } from '../../../../helpers/utils';
import { useAllieAuth, useAppTranslations } from '../../../../hooks';

interface CreatePasswordProps {
  email: string;
  password: string;
}

const namespace = 'create-success';

export const CreateSuccess: React.FC<CreatePasswordProps> = ({ email, password }) => {
  const { emailLogin } = useAllieAuth();
  const {
    CREATE_NEW_PASSWORD_SUCCESS_BODY_TITLE,
    GO_TO_MY_ACCOUNT,
    RESET_SUCCESS_BODY_SUBTITLE,
    RESET_SUCCESS_TITLE,
  } = useAppTranslations();

  const onSubmit = async () => {
    emailLogin(email, password, undefined, undefined, true);
  };

  return (
    <CreateSuccessContainer isMobile={isMobile}>
      <AllieText type="h3">{RESET_SUCCESS_TITLE}</AllieText>
      <div className={`${namespace}-gif`}>
        <AllieImg src="assets/change-password-success.gif" />
      </div>
      <div className={`${namespace}-body`}>
        <AllieText type="h4" color="neutral-50" weight={600}>
          {CREATE_NEW_PASSWORD_SUCCESS_BODY_TITLE}
        </AllieText>
        <AllieText type="body1" color="neutral-50">
          {RESET_SUCCESS_BODY_SUBTITLE}
        </AllieText>
      </div>
      <div className={`${namespace}-confirm`}>
        <AllieButton
          onClick={onSubmit}
          corner="rounded-edges"
          allieColor="primary"
          allieSize="small"
        >
          {GO_TO_MY_ACCOUNT}
        </AllieButton>
      </div>
    </CreateSuccessContainer>
  );
};
